import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { API_URL } from "../Constants"; // Import API_URL
import UserCard from './UserCard';

class TeamMember extends Component {
  constructor() {
    super();
    this.state = {
      data: []
    }
  }
  componentDidMount() {
    fetch(`${API_URL}/app/api/v1/teams?filter=division.id==` + this.props.divisionId)
      .then(results => {
        return results.json();
      }).then(resp => {
        this.setState({ data: resp });
      });
  }

  state = {
    isShowingUserMenu: false
  };

  render() {
    return (
        <Row>
          <div className="content">
            {this.state.data.map(team => (
                <UserCard  divisionId={this.props.divisionId} team={team} />
            ))}
          </div>
        </Row>
    );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user
});

export default connect(mapStateToProps)(TeamMember);


// WEBPACK FOOTER //
// ./src/components/TileIcon/TeamMember.js